import { Component, inject } from '@angular/core';
import { TenantService } from '@core/tenant/tenant.service';

@Component({
  selector: 'tx-site-autodepoca',
  templateUrl: './site-autodepoca.component.html',
  styleUrls: ['./site-autodepoca.component.scss'],
})
export class SiteAutodepocaComponent {
  private _tenant = inject(TenantService);

  /** URL do botão flutuante de WhatsApp — null se desactivado ou sem número. */
  get whatsappFloatUrl(): string | null {
    const ds = this._tenant.profile?.dealerSite;
    if (!ds?.enableWhatsappFloat) return null;
    const w = ds.socialLinks?.whatsapp;
    if (!w) return null;
    const v = w.replace(/\s+/g, '');
    return /^https?:/i.test(v)
      ? v
      : `https://wa.me/${v.replace(/[^\d+]/g, '')}`;
  }
}
